export default "__VITE_ASSET__DVNh6bEB__"